import { Component, Injectable } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { ApiResponseActions } from './api-response-actions';
import { DispatcherModule } from '../dispatcher.module';
import { AppState } from '../state.model';

@Injectable({
  providedIn: DispatcherModule,
})
export class ApiResponseDispatcher {
  constructor(private ngRedux: NgRedux<AppState>) { }
  /**
   * setSubscriptionResponse Store the result of the subscription of packages and wifi
   * @param result result  from api call
   **/
  public setSubscriptionResponse(result: object, type: string): void {
    this.ngRedux.dispatch(ApiResponseActions.setSubscriptionResponse(result, type));
  }
  /**
   * setSubscriptionState sets the state of subscription
   * @param waive flag
   **/
  public setSubscriptionState(state: boolean): void {
    this.ngRedux.dispatch(ApiResponseActions.setSubscriptionState(state));
  }
  /**
   * setVinlistResponse Store the result of vinlist
   * @param result result  from api call
   **/
  public setVinlistResponse(result: any): void {
    this.ngRedux.dispatch(ApiResponseActions.setVinlistResponse(result));
  }
  /**
 * setLookUpkeysResponse Store the result of lookupKeys
 * @param result result  from api call
 **/
  public setLookUpkeysResponse(result: any): void {
    this.ngRedux.dispatch(ApiResponseActions.setLookUpkeysResponse(result));
  }
  /**
   * setPreview Store the result of vinlist
   * @param result result  from api call
   **/
  public setPreview(result: any): void {
    this.ngRedux.dispatch(ApiResponseActions.setPreview(result));
  }
  /**
   * setCustomerResponse Store the result of get customer
   * @param result result  from api call
   **/
  public setCustomerResponse(result: object): void {
    this.ngRedux.dispatch(ApiResponseActions.setCustomerResponse(result));
  }
  /**
   * setUpdateCustomerResponse Store the result of update customer
   * @param result result  from api call
   **/
  public setUpdateCustomerResponse(result: object): void {
    this.ngRedux.dispatch(ApiResponseActions.setUpdateCustomerResponse(result));
  }
  /**
   * setSubscribedCustomer Store the result of vinlist
   * @param result result  from api call
   **/
  public setSubscribedCustomer(result: object): void {
    this.ngRedux.dispatch(ApiResponseActions.setSubscribedCustomer(result));
  }
  /**
   * setSubHistoryCustomer Store the result of account
   * @param result result from api call
   **/
  public setSubscriptionHistoryCustomer(result: object): void {
    this.ngRedux.dispatch(ApiResponseActions.setSubscriptionHistoryCustomer(result));
  }
  /**
   * setCustomerResponse Store the result of vinlist
   * @param result result  from api call
   **/
  public setRemoteCustomerResponse(result: object): void {
    this.ngRedux.dispatch(ApiResponseActions.setRemoteCustomerResponse(result));
  }
  /**
   * setfindVehicleResponse Store the result of vehicel
   * @param result result  from api call
   **/
  public setfindVehicleResponse(result: object): void {
    this.ngRedux.dispatch(ApiResponseActions.setfindVehicleResponse(result));
  }
  /**
   * setMetaDataResponse Store the result of asi metadata
   * @param result result  from api call
   **/
  public setMetaDataResponse(result: object): void {
    this.ngRedux.dispatch(ApiResponseActions.setMetaDataResponse(result));
  }
  /**
   * setRemoteCommandResponse Store the result of vinlist
   * @param result result  from api call
   **/
  public setRemoteCommandResponse(result: object): void {
    this.ngRedux.dispatch(ApiResponseActions.setRemoteCommandResponse(result));
  }
  /**
   * setSubscriptionHistoryResponse Store the result of subscription history
   * @param result result  from api call
   **/
  public setSubscriptionHistoryResponse(result: object): void {
    this.ngRedux.dispatch(
      ApiResponseActions.setSubscriptionHistoryResponse(result)
    );
  }
  /**
   * setCustomerHistoryResponse Store the result of customer history
   * @param result result  from api call
   **/
  setCustomerHistoryResponse(result: object) {
    this.ngRedux.dispatch(
      ApiResponseActions.setCustomerHistoryResponse(result)
    );
  }
  /**
   *  setDeleteAccountResponse Store the result of deleteaccount
   * @param result result  from api call
   **/
  public setDeleteAccountResponse(result: object): void {
    this.ngRedux.dispatch(ApiResponseActions.setDeleteAccountResponse(result));
  }
  /**
   * setWifiStatusResponse Store the result of wifiState
   * @param result result  from api call
   **/
  public setWifiStatusResponse(result: object): void {
    this.ngRedux.dispatch(ApiResponseActions.setWifiStatusResponse(result));
  }

  /**
   * setVerifyAddressResponse Store the result of verify address
   * @param result result  from api call
   **/
  public setVerifyAddressResponse(result: object): void {
    this.ngRedux.dispatch(ApiResponseActions.setVerifyAddressResponse(result));
  }
  /**
   * setTciReport Store the result of the subscription of tci report
   * @param result result  from api call
   **/
  public setTciReport(result: object): void {
    this.ngRedux.dispatch(ApiResponseActions.setTciReport(result));
  }
  /**
   * setSxmReport Store the result of the subscription of sxm report
   * @param result result  from api call
   **/
  public setSxmReport(result: object): void {
    this.ngRedux.dispatch(ApiResponseActions.setSxmReport(result));
  }
  /**
 * setProvisionHistoryResponse Store the result of customer history
 * @param result result  from api call
 **/
  setProvisionHistoryResponse(result: object) {
    this.ngRedux.dispatch(
      ApiResponseActions.setProvisionHistoryResponse(result)
    );
  }

  /**
   * setTelematicsReport Store the result of the subscription of telematics report
   * @param result result  from api call
   **/
  public setTelematicsReport(result: object): void {
    this.ngRedux.dispatch(ApiResponseActions.setTelematicsReport(result));
  }
  /**
   * setGetProvisioningResponse Store the result of get provisioning
   * @param result result  from api call
   **/
  public setGetProvisioningResponse(result: object): void {
    this.ngRedux.dispatch(
      ApiResponseActions.setGetProvisioningResponse(result)
    );
  }
  /**
   * setRetrigerProvisioningResponse Store the result of get provisioning
   * @param result result  from api call
   **/
  public setRetrigerProvisioningResponse(result: object): void {
    this.ngRedux.dispatch(
      ApiResponseActions.setRetrigerProvisioningResponse(result)
    );
  }
  /**
   * setFandaRejects store the response of API
   * @param response response  from api call
   **/
  setFandaRejects(response: object) {
    this.ngRedux.dispatch(ApiResponseActions.setFandaRejects(response));
  }
  /**
   * set21mmToken store the response of API
   * @param response response  from api call
   **/
  set21mmToken(response: object) {
    this.ngRedux.dispatch(ApiResponseActions.set21mmToken(response));
  }
  /**
   * setVcmHistory store the response of API
   * @param response response  from api call
   **/
  setVcmHistory(response: object) {
    this.ngRedux.dispatch(ApiResponseActions.setVcmHistory(response));
  }
  /**
   * setClearVin store the response of API
   * @param response response  from api call
   **/
  setClearVin(response: object) {
    this.ngRedux.dispatch(ApiResponseActions.setClearVin(response));
  }
  /**
   * setBlackListVin store the response of API
   * @param response response  from api call
   **/
  setBlackListVin(response: object) {
    this.ngRedux.dispatch(ApiResponseActions.setBlackListVin(response));
  }
  /**
   * setClearChipId store the response of API
   * @param response response  from api call
   **/
  setClearChipId(response: object) {
    this.ngRedux.dispatch(ApiResponseActions.setClearChipId(response));
  }
  /**
   * UpdateFanda store the response of API
   * @param response response  from api call
   **/
  UpdateFanda(response: object) {
    this.ngRedux.dispatch(ApiResponseActions.UpdateFanda(response));
  }
  /**
   * setUpdateEmergencyContact Store the result of update emergency contact
   * @param result result  from api call
   **/
  setUpdateEmergencyContactResponse(result: object) {
    this.ngRedux.dispatch(
      ApiResponseActions.setUpdateEmergencyContact(result)
    );
  }
  /**
 * setEmergencyContactResponse Store the result of emergency contact
 * @param result result  from api call
 **/
  setEmergencyContactResponse(result: object) {
    this.ngRedux.dispatch(
      ApiResponseActions.setEmergencyContactResponse(result)
    );
  }
  /**
   * setUpdateEmergencyContact Store the result of update emergency contact
   * @param result result  from api call
   **/
  setZuoraResponse(result: object) {
    this.ngRedux.dispatch(
      ApiResponseActions.setZuoraResponse(result)
    );
  }
  /**
   * setJsdGroupInfoResponse Store the result of get jsd group info
   * @param result result  from api call
   **/
  setJsdGroupInfoResponse(result: object) {
    this.ngRedux.dispatch(
      ApiResponseActions.setJsdGroupInfoResponse(result)
    );
  }
  /**
  * setPhoneConfig Store the result of Phone Config
  * @param result result  from api call
  **/
  setPhoneConfig(result: object) {
    this.ngRedux.dispatch(
      ApiResponseActions.setPhoneConfigResponse(result)
    );
  }
  /**
 * setPhoneCompatibilities Store the result of Phone Compatibilities
 * @param result result  from api call
 **/
  setPhoneCompatibilities(result: object) {
    this.ngRedux.dispatch(
      ApiResponseActions.setPhoneCompatibilitiesResponse(result)
    );
  }
  /**
   * setPnCStatusResponse Store the result of pnc status
   * @param result result  from api call
   **/
    setPncStatusResponse(result: object) {
      this.ngRedux.dispatch(
        ApiResponseActions.setPncStatusResponse(result)
      );
    }
  /**
   * setCmsCreateTicketResponse Store the result of update emergency contact
   * @param result result  from api call
   **/
  setCmsCreateTicketResponse(result: object) {
    this.ngRedux.dispatch(
      ApiResponseActions.setCmsCreateTicketResponse(result)
    );
  }
  /**
   * setTssResponse Store the result of get tss
   * @param result result  from api call
   **/
  setTssResponse(result: object) {
    this.ngRedux.dispatch(
      ApiResponseActions.setTssResponse(result)
    );
  }
  /**
   * setPartialFactoryDataFeed Store the result of the subscription of partial factory data feed
   * @param result result  from api call
   **/
  setPartialFactoryDataFeed(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setPartialFactoryDataFeed(result));
  }
  /**
   * setFullFactoryDataFeed Store the result of the subscription of full factory data feed
   * @param result result  from api call
   **/
  setFullFactoryDataFeed(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setFullFactoryDataFeed(result));
  }
  /**
   * setAirDataFeed Store the result of the subscription of air data feed
   * @param result result  from api call
   **/
  setAirDataFeed(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setAirDataFeed(result));
  }
  /**
   * setUserRole Store the result of the subscription of given user roles
   * @param result result  from api call
   **/
  setUserRole(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setUserRole(result));
  }
  /**
   * setUserRoleUpdate Store the result of the subscription of user role update
   * @param result result  from api call
   **/
  setUserRoleUpdate(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setUserRoleUpdate(result));
  }
  /**
   * setUserDelete Store the result of the subscription of delete user update
   * @param result result  from api call
   **/
  setUserDelete(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setUserDelete(result));
  }
  /*
   * setValidateCMSUser Store the result of the setValidateCMSUser
   * @param response result  from api call
   **/
  setValidateCMSUser(response: object) {
    this.ngRedux.dispatch(ApiResponseActions.setValidateCMSUser(response));
  }
  /**
   * setGuidStatus Store the result of the subscription of guid status
   * @param result result  from api call
   **/
  setGuidStatus(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setGuidStatus(result));
  }
  /**
   * setHomeDealer Store the result of the Home dealer details
   * @param result result  from api call
   **/
  setHomeDealer(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setHomeDealer(result));
  }
  /**
   * setPreferredDealer Store the result of the Preferred dealer details
   * @param result result  from api call
   **/
  setPreferredDealer(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setPreferredDealer(result));
  }
  /**
   * setOutageBannerMessage Store the result of the outage banner response
   * @param result result  from api call
   **/
  setOutageBannerMessage(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setOutageBannerMessage(result));
  }
  /**
   * setVehicleHistory Store the result of the vehicle history
   * @param result result  from api call
   **/
  setVehicleHistory(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setVehicleHistory(result));
  }
  /**
   * setPackageProducts Store the result of the product packages
   * @param result result  from api call
   **/
  setPackageProducts(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setPackageProducts(result));
  }
  /**
   * setTrialLengthsResponse Store the result of trial lengths
   * @param result result  from api call
   **/
  setTrialLengthsResponse(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setTrialLengthsResponse(result));
  }
  /**
   * setLinkedAccounts Store the result of linked accounts
   * @param result result  from api call
   **/
  setLinkedAccounts(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setLinkedAccounts(result));
  }
  /**
   * set21MMUserProfileSettings Store the result of 21MM user profile settings
   * @param result result  from api call
   **/
  set21MMUserProfileSettings(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.set21MMUserProfileSettings(result));
  }
  /**
   * setGoodwillPackages Store the result of the response after hitting the Goodwill API
   * @param result result  from api call
   **/
  setGoodwillPackages(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.setGoodwillPackages(result));
  }
  /**
   * submitGoodwillPackages Store the result of the response after hitting the submit Goodwill API
   * @param result result  from api call
   **/
  submitGoodwillPackages(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.submitGoodwillPackages(result));
  }
  /**
   * getDataConsents Store the result of the response after hitting the getDataConsents API
   * @param result result  from api call
   **/
  getDataConsents(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.getDataConsents(result));
  }  
  
  /**
   * getSmsConsent Store the result after hitting GET /v1/portal/consent/account for customer SMS consent
   */
  getSmsConsent(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.getSmsConsent(result));
  }
/**
   * updateRemoteUser Store the result of the response after hitting the updateRemoteUser API
   * @param result result  from api call
   **/
  updateRemoteUser(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.updateRemoteUser(result));

  }
  /**
   * getHuCompany Store the result of the response after hitting the getHuCompany API
   * @param result result  from api call
   **/
  getHuCompany(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.getHuCompany(result));
  }
  /**
  * addDCMActivation Store the result of the response after hitting the addDCMActivation API
  * @param result result  from api call
  **/
  addDCMActivation(result: object) {
    this.ngRedux.dispatch(ApiResponseActions.addDCMActivation(result));
  }
  /**
   * setSurvivorAccountResponse Store the result of survivor account
   * @param result result  from api call
   **/
    public setSurvivorAccountResponse(result: any): void {
      this.ngRedux.dispatch(ApiResponseActions.setSurvivorAccountResponse(result));
    }

}
